/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Phase2_Fix_Call_Sample_OneInputs */

const en_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} call`)
};

const zh_hans1_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次调用`)
};

const pt_br2_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chamada`)
};

const es_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} llamada`)
};

const fr_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} appel`)
};

const de_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Aufruf`)
};

const ru_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} вызов`)
};

const it_phase2_fix_call_sample_one = /** @type {(inputs: Phase2_Fix_Call_Sample_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chiamata`)
};

/**
* | output |
* | --- |
* | "{count} call" |
*
* @param {Phase2_Fix_Call_Sample_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_call_sample_one = /** @type {((inputs: Phase2_Fix_Call_Sample_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Call_Sample_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_call_sample_one(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_call_sample_one(inputs)
	if (locale === "es") return es_phase2_fix_call_sample_one(inputs)
	if (locale === "fr") return fr_phase2_fix_call_sample_one(inputs)
	if (locale === "de") return de_phase2_fix_call_sample_one(inputs)
	if (locale === "ru") return ru_phase2_fix_call_sample_one(inputs)
	if (locale === "it") return it_phase2_fix_call_sample_one(inputs)
	return en_phase2_fix_call_sample_one(inputs)
});